import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export type SanitizeType = 'URL' | 'HTML' | 'RESOURCE_URL' | 'STYLE' | 'SCRIPT';

@Pipe({
  name: 'sanitize',
  pure: true,
  standalone: true,
})
export class SanitizePipe implements PipeTransform {
  private domSanitizer = inject(DomSanitizer);

  transform(value: string, type: SanitizeType) {
    switch (type) {
      case 'HTML':
        return this.domSanitizer.bypassSecurityTrustHtml(value);
      case 'URL':
        return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
      case 'STYLE':
        return this.domSanitizer.bypassSecurityTrustStyle(value);
      case 'SCRIPT':
        return this.domSanitizer.bypassSecurityTrustScript(value);
      case 'RESOURCE_URL':
        return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
    }
  }
}
